// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferV2Schema {
  /** Дополнительный телефон **/
  additionalPhone: string;
  /** Адрес объекта **/
  address: string;
  /** Площадь **/
  area?: number;
  /** Назначен фонд **/
  assignedFund: boolean;
  /** Могу принять **/
  availableFor: string[];
  /** Доступный период **/
  availablePeriod: string;
  /** Количество кроватей **/
  bedsCount: number;
  /** Описание кроватей **/
  bedsDescription: string;
  /** Комментарий к заявке **/
  comment: string;
  /** Дата создания **/
  createdAt: string;
  /** Удобства **/
  facilities: string[];
  /** Этаж **/
  floor?: number;
  /** Название фонда **/
  fundName?: string;
  /** Количество гостей **/
  guestsCount: number;
  /** ID записи **/
  id: number;
  /** Город **/
  location: string;
  /** Имя **/
  name: string;
  /** Тип объекта **/
  objectType: EObjectType;
  /** Другие пожелания **/
  otherWishes: string;
  /** Телефон **/
  phone: string;
  /** Сумма или комментарий **/
  priceDescription: string;
  /** Тип цены **/
  priceType: EPriceType;
  /** Готов принять **/
  readyAccommodate: EReadyAccommodate[];
  /** Количество комнат **/
  roomsCount?: ERoomsCount;
  /** Статус **/
  status: EStatus;
  /** Имя пользователя **/
  telegram: string;
}

export enum EObjectType {
  /** Кровать **/
  'Bed' = 'bed',
  /** Квартира **/
  'Flat' = 'flat',
  /** Дом **/
  'House' = 'house',
  /** Комната **/
  'Room' = 'room',
}
export enum EPriceType {
  /** Бесплатно **/
  'Free' = 'free',
  /** За символическую плату **/
  'Symbolic' = 'symbolic',
  /** За оплату квитанций **/
  'Utility_bill' = 'utility_bill',
}
export enum EReadyAccommodate {
  /** На время лечения **/
  'During_treatment' = 'during_treatment',
  /** Пожар **/
  'Fire' = 'fire',
  /** Беженцы **/
  'Refugees' = 'refugees',
  /** Разлив рек **/
  'River_flooding' = 'river_flooding',
}
export enum ERoomsCount {
  /** 5 **/
  'Five' = 'five',
  /** 4 **/
  'Four' = 'four',
  /** 1 **/
  'One' = 'one',
  /** 6+ **/
  'Six_and_more' = 'six_and_more',
  /** Студия **/
  'Studio' = 'studio',
  /** 3 **/
  'Three' = 'three',
  /** 2 **/
  'Two' = 'two',
}
export enum EStatus {
  /** Свободно **/
  'Available' = 'available',
  /** Занято **/
  'Busy' = 'busy',
  /** Не актуальна **/
  'Canceled' = 'canceled',
  /** Уточняется заселение **/
  'Confirming' = 'confirming',
  /** Отклонено **/
  'Declined' = 'declined',
  /** На модерации **/
  'Moderation' = 'moderation',
  /** Новая **/
  'New' = 'new',
  /** Не дозвонились **/
  'Phone_not_available' = 'phone_not_available',
}
